export const STEAM_URL = `https://store.steampowered.com/app/1619420/Diebrary/?utm_source=diebrarygame`

export const STEAM_PARAMS = {
  'dogear': '&utm_content=dogear',
  'character': '&utm_content=character_placeholder',
  'weapon': '&utm_content=weapon_placeholder',
  'end_run': '&utm_content=end_run',
  'story_activity_feed': '&utm_content=story_activity_feed',
}